module.exports = __webpack_public_path__ + "img/ft_fish_meal.993d4f56.jpg";